import dayjs from "dayjs";

export const getInitialDateRange = (
  startDate?: Date | string,
  offset = 2000,
  offsetStart = true
): [Date, Date] => {
  const currentTime = dayjs(startDate);
  const start = offsetStart
    ? currentTime.subtract(offset, "millisecond").toDate()
    : (startDate as Date);
  const end = currentTime.add(offset, "millisecond").toDate();

  return [start, end];
};
